import { useLanding } from "@/context/LandingContext";
import { SEMINAR } from "@/seminars";
import { Countdown } from "./Countdown";
import { InteractiveSection, MotionBg } from "./MotionBg";
import { RegistrationForm } from "./RegistrationForm";
import { ClosedNotice } from "./RegistrationClosed";
import { Reveal } from "./Reveal";

export function RegisterSection() {
  const { t, lang, selectedEvent, sessionTag } = useLanding();
  const r = t.register;
  if (SEMINAR.registrationClosed) {
    return (
      <InteractiveSection className="section section-dark register-section register-section-closed" id="register" data-testid="register-section">
        <MotionBg variant="network" />
        <div className="container">
          <Reveal className="register-closed-wrap">
            <ClosedNotice />
          </Reveal>
        </div>
      </InteractiveSection>
    );
  }
  return (
    <InteractiveSection className="section section-dark register-section" id="register" data-testid="register-section">
      <MotionBg variant="network" />
      <div className="container register-grid">
        <Reveal className="register-copy">
          <p className="eyebrow"><span className="eyebrow-no">10</span>{r.eyebrow}</p>
          <h2>
            {r.title[0]}
            <span className="gold">{r.title[1]}</span>
          </h2>
          <p className="lead">{r.lead}</p>
          <div className="event-card" data-testid="event-card">
            <div className="event-card-row">
              <small>{r.dateLabel}</small>
              <strong data-testid="event-date">{selectedEvent.label[lang]}</strong>
            </div>
            <div className="event-card-row">
              <small>{r.timeLabel}</small>
              <strong data-testid="event-time">{r.time}</strong>
            </div>
            <div className="event-card-row">
              <small>{r.venueLabel}</small>
              <strong data-testid="event-venue">{r.venue}</strong>
            </div>
            <div className="event-card-row">
              <small>{r.speakerLabel}</small>
              <strong data-testid="event-speaker">{sessionTag(selectedEvent)}</strong>
            </div>
            <Countdown />
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <RegistrationForm />
        </Reveal>
      </div>
    </InteractiveSection>
  );
}
